exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".loading-back-greyed[data-v-4ae1524e]{background-color:hsla(0,0%,78.4%,.4);width:100%;min-height:65vh;position:absolute;top:0;left:0}.scoped-editor-row[data-v-4ae1524e]:before{border-top:1px solid #dedede;width:95%;margin:.5rem auto;display:block}.scoped-keep-in-line[data-v-4ae1524e]{display:block;white-space:nowrap;position:relative}input.has-counter[data-v-4ae1524e]{padding-right:36px}", ""]);

// exports
